import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ScrollTrigger from 'react-scroll-trigger';
import {Slide, withStyles} from "@material-ui/core";
import withWidth, {isWidthDown} from '@material-ui/core/withWidth';
import styles from "./styles"
import {enterTime, imageNames} from "../constants";
import TitleWithText from "../Components/TitleWithText";
import Header from "../Components/Header";
import FullCarousel from "../Components/FullCarousel"
import Footer from "../Components/Footer";
import {translate} from "react-i18next";
import {compose} from "redux";

const RouteHome = ({t, classes, width}) => {
    const [values, setValues] = React.useState({
        firstActive: false,
        secondActive: false,
        thirdActive: false,
        fourthActive: false,
        fifthActive: false,
        sixthActive: false,
    });
    const [allActive, setAllActive] = React.useState(false);

    const setActive = number => {
        setValues({...values, [number]: true});
    };

    const handleScrollToBottom = () => {
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = Math.round(windowHeight + window.pageYOffset);
        if (windowBottom >= docHeight) {
            setValues({
                firstActive: true,
                secondActive: true,
                thirdActive: true,
                fourthActive: true,
                fifthActive: true,
                sixthActive: true,
            });
        }
    };

    return (
        <div className={classes.root}>
            {window.addEventListener("scroll", handleScrollToBottom)}
            {isWidthDown("sm", width) && allActive === false && setAllActive(true)}
            <Header activePage={"home"}/>
            <div>
                {imageNames.length && <FullCarousel images={imageNames}/>}
                <div className={classes.textBox}>
                    <TitleWithText title={t("main:home")} text={t("main:home_text")} titleSize={"35px"}/>
                    <div className={classNames(classes.textElement, classes.leftElement)}>
                        <Slide direction={"right"} in={values.firstActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_header2")} text={t("main:home_text2")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("firstActive")}/>
                    <div className={classNames(classes.bigText, classes.rightElement)}>
                        <Slide direction={"left"} in={values.secondActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_header3")} text={t("main:home_text3")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("secondActive")}/>
                    <div className={classNames(classes.smallText, classes.leftElement)}>
                        <Slide direction={"right"} in={values.thirdActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_header4")} text={t("main:home_text4")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("thirdActive")}/>
                    <div className={classNames(classes.smallText, classes.rightElement)}>
                        <Slide direction={"left"} in={values.fourthActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_header5")} text={t("main:home_text5")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("fourthActive")}/>
                    <div className={classNames(classes.smallText, classes.leftElement)}>
                        <Slide direction={"right"} in={values.fifthActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_header6")} text={t("main:home_text6")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("fifthActive")}/>
                    <div className={classNames(classes.smallText, classes.rightElement)}>
                        <Slide direction={"left"} in={values.sixthActive || allActive} mountOnEnter
                               timeout={{enter: enterTime}}>
                            <TitleWithText title={t("main:home_bottom_title")} text={t("main:home_bottom_text")}/>
                        </Slide>
                    </div>
                    <ScrollTrigger onEnter={() => setActive("sixthActive")}/>
                </div>
            </div>
            <Footer/>
        </div>
    )
};

export default compose(
    withWidth(),
    translate(),
    withStyles(styles)
)(RouteHome);

FullCarousel.propTypes = {
    classes: PropTypes.object.isRequired,
};